import sendAjax from '@/api/http'

export default {
  //腾讯云上传
  tencentUploadToken: params => {
    return sendAjax('get', `tencent/uploadedToken/${params.path}`, params)
  },
  // 新建文章
  articleNewlyBuild: params => {
    return sendAjax('post', `article/add`, params)
  },
  // 修改文章
  articleModify: params => {
    return sendAjax('post', `article/modify`, params)
  },
  // 文章详情 -- 后台
  articleDetails: params => {
    return sendAjax('get', `article/get4Admin`, params)
  },
  // 文章列表
  articleList: params => {
    return sendAjax('get', `article/find4Admin`, params)
  },
  // 删除文章
  articleDel: params => {
    return sendAjax('post', `article/remove`, params)
  },
  // 修改文章状态
  articleModifyStatus: params => {
    return sendAjax('post', `article/modifyStatus`, params)
  },

  // 新建文物
  culRelicNewlyBuild: params => {
    return sendAjax('post', `cultural/add`, params)
  },
  // 修改文物
  culRelicModify: params => {
    return sendAjax('post', `cultural/modify`, params)
  },
  // 文物详情 -- 后台
  culRelicDetails: params => {
    return sendAjax('get', `cultural/get4Admin`, params)
  },
  // 文物列表 -- 后台
  culRelicList: params => {
    return sendAjax('get', `cultural/find4Admin`, params)
  },



// 删除文物
  culRelicDel: params => {
    return sendAjax('post', `cultural/remove`, params)
  },
  // 修改文物状态
  culRelicModifyStatus: params => {
    return sendAjax('post', `cultural/modifyStatus`, params)
  },


  // 新建相册
  albumNewlyBuild: params => {
    return sendAjax('post', `photo/add`, params)
  },
  // 修改相册
  albumModify: params => {
    return sendAjax('post', `photo/modify`, params)
  },
  // 相册详情
  albumDetails: params => {
    return sendAjax('get', `photo/get`, params)
  },
  // 相册 列表
  albumList: params => {
    return sendAjax('get', `photo/find`, params)
  },
  // 删除相册
  albumDel: params => {
    return sendAjax('post', `photo/remove`, params)
  },

/*


  // 修改相册状态
  albumModifyStatus: params => {
    return sendAjax('post', `cultural/modifyStatus`, params)
  },
*/




}
